import { render, staticRenderFns } from "./setAddress.vue?vue&type=template&id=765c1935&scoped=true&"
import script from "./setAddress.vue?vue&type=script&lang=ts&"
export * from "./setAddress.vue?vue&type=script&lang=ts&"
import style0 from "./setAddress.vue?vue&type=style&index=0&id=765c1935&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765c1935",
  null
  
)

export default component.exports